<template>
  <div>
    <div class="color-default mb-5">
      <router-link :to="{
        name: 'Adaugare contract',
        params: { clientId: this.$route.params.clientId },
      }" v-if="this.hasAccess(this.PERMISSION_LEVEL_TECHNICIAN)">
        <v-btn color="orange" class="mx-2 my-2">+ Contract</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adaugare livret',
        params: { clientId: this.$route.params.clientId },
      }" v-if="this.hasAccess(this.PERMISSION_LEVEL_TECHNICIAN)">
        <v-btn color="purple darken-1" class="mx-2 my-2">+ Autorizatie</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adaugare raport',
        params: { clientId: this.$route.params.clientId },
      }" v-if="this.hasAccess(this.PERMISSION_LEVEL_ADMIN)">
        <v-btn color="red" class="mx-2 my-2">+ Proces Verbal</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adaugare fisa de lucrari',
        params: { clientId: this.$route.params.clientId },
      }" v-if="this.hasAccess(this.PERMISSION_LEVEL_TECHNICIAN)">
        <v-btn color="green" class="mx-2 my-2">+ Fisa Lucrari</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adaugare factura',
        params: { clientId: this.$route.params.clientId },
      }" v-if="this.hasAccess(this.PERMISSION_LEVEL_TECHNICIAN)">
        <v-btn color="cyan lighten-1" class="mx-2 my-2">+ Factura</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adauga VTP ANRE 2 ani',
        params: { clientId: this.$route.params.clientId },
      }" v-if="
          this.hasRole(PERMISSION_LEVEL_ADMIN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN_ANRE)
        ">
        <v-btn color="teal accent-4" class="mx-2 my-2">+ VTP 2ANI ANRE W</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adauga VTP ANRE 10 ani',
        params: { clientId: this.$route.params.clientId },
      }" v-if="
          this.hasRole(PERMISSION_LEVEL_ADMIN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN_ANRE)
        ">
        <v-btn color="green accent-4" class="mx-2 my-2">+ VTP 10ANI ANRE W</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adauga VTP ANRE 2 ani SRB',
        params: { clientId: this.$route.params.clientId },
      }" v-if="
          this.hasRole(PERMISSION_LEVEL_ADMIN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB)
        ">
        <v-btn color="teal accent-4" class="mx-2 my-2">+ VTP 2ANI ANRE SRB</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adauga VTP ANRE 10 ani SRB',
        params: { clientId: this.$route.params.clientId },
      }" v-if="
          this.hasRole(PERMISSION_LEVEL_ADMIN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB)
        ">
        <v-btn color="green accent-4" class="mx-2 my-2">+ VTP 10ANI SRB</v-btn>
      </router-link>

      <router-link :to="{
        name: 'Adauga PV IUGN SRB',
        params: { clientId: this.$route.params.clientId },
      }" v-if="
          this.hasRole(PERMISSION_LEVEL_ADMIN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN) ||
          this.hasRole(PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB)
        ">
        <v-btn color="green accent-5" class="mx-2 my-2">+ PV IUGN SRB</v-btn>
      </router-link>
    </div>

    <v-data-table :headers="headers" :items="listDocuments" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            Client: {{ $store.state.clients.client.name }} - Adresa:
            {{ $store.state.clients.client.street }},
            {{ $store.state.clients.client.addressDetails }}
          </v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoClient" v-bind="attrs" v-on="on">login</v-icon>
          </template>
          <span>Vezi client</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="download(item)" v-bind="attrs" v-on="on"> get_app </v-icon>
          </template>
          <span>Descarca</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="sendEmail(item)" v-bind="attrs" v-on="on"> send </v-icon>
          </template>
          <span>Trimite email</span>
        </v-tooltip>
        <v-tooltip left v-if="item.invoice && show">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="syncEInvoice(item)" v-bind="attrs" v-on="on">
              sync
            </v-icon>
          </template>
          <span>Sincronizare efactura</span>
        </v-tooltip>
        <v-tooltip v-if="item.type === 'invoice'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoInvoice(item.invoice.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare factura</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'contract'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoContract(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare contract</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'livret'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoLivret(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare livret</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'report'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoReport(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare proces verbal</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'worksheet'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoWorksheet(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare fisa lucrari</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'vtp-anre-2'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoVTPANRE2(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare VTP 2ANI ANRE</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'vtp-anre-10'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoVTPANRE10(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare VTP 10ANI ANRE</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'vtp-anre-2-srb'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoVTPANRE2SRB(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare VTP 2ANI ANRE</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'vtp-anre-10-srb'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoVTPANRE10SRB(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare VTP 10ANI ANRE</span>
        </v-tooltip>

        <v-tooltip v-if="item.type === 'pv-iugn-srb'" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mr-2" @click="gotoPVIUGNSRB(item.id)" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editare PV IUGN ANRE</span>
        </v-tooltip>

        <v-icon v-if="show" @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  hasAccess,
  hasRole,
  PERMISSION_LEVEL_ADMIN,
  PERMISSION_LEVEL_TECHNICIAN,
  PERMISSION_LEVEL_TECHNICIAN_ANRE,
  PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB,
} from '../../utils/permissions';

export default {
  name: 'ListDocuments',
  data() {
    return {
      show: hasAccess(PERMISSION_LEVEL_ADMIN),
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Tip',
          align: 'center',
          value: 'typeName',
          sortable: true,
        },
        {
          text: 'Nume',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Numar',
          align: 'center',
          value: 'number',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
      PERMISSION_LEVEL_ADMIN,
      PERMISSION_LEVEL_TECHNICIAN,
      PERMISSION_LEVEL_TECHNICIAN_ANRE,
      PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB,
    };
  },
  created() {
    this.$store.dispatch('documents/getDocuments', this.$route.params.clientId);
    this.$store.dispatch('clients/getClient', this.$route.params.clientId);
  },
  computed: {
    listDocuments() {
      return this.$store.state.documents.all.map((el) => {
        el.typeName = this.formatDocumentType(el.type);
        return el;
      });
    },
  },
  methods: {
    hasAccess,
    hasRole,

    gotoCreate() {
      this.$router.push({
        path: `/clients/${this.$route.params.clientId}/documents/create`,
      });
    },
    gotoClient() {
      this.$router.push({
        name: 'Editare client',
        params: { id: this.$route.params.clientId },
      });
    },
    gotoInvoice(id) {
      this.$router.push({
        name: 'Editare factura',
        params: { id },
      });
    },
    gotoContract(id) {
      this.$router.push({
        name: 'Editare contract',
        params: { id },
      });
    },
    gotoReport(id) {
      this.$router.push({
        name: 'Editare raport',
        params: { id },
      });
    },
    gotoLivret(id) {
      this.$router.push({
        name: 'Editare livret',
        params: { id },
      });
    },
    gotoWorksheet(id) {
      this.$router.push({
        name: 'Editare fisa de lucrari',
        params: { id },
      });
    },

    gotoVTPANRE2(id) {
      this.$router.push({
        name: 'Editare VTP ANRE 2 ani',
        params: { id },
      });
    },
    gotoVTPANRE10(id) {
      this.$router.push({
        name: 'Editare VTP ANRE 10 ani',
        params: { id },
      });
    },
    gotoVTPANRE2SRB(id) {
      this.$router.push({
        name: 'Editare VTP ANRE 2 ani SRB',
        params: { id },
      });
    },
    gotoVTPANRE10SRB(id) {
      this.$router.push({
        name: 'Editare VTP ANRE 10 ani SRB',
        params: { id },
      });
    },
    gotoPVIUGNSRB(id) {
      this.$router.push({
        name: 'Editare PV IUGN SRB',
        params: { id },
      });
    },
    sendEmail(item) {
      this.$store.dispatch('documents/sendEmail', {
        clientId: this.$route.params.clientId,
        documentId: item.id,
      });
    },
    syncEInvoice(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('documents/syncEInvoice', item.invoice.id);
      }
    },
    async download(item) {
      const response = await this.$store.dispatch('documents/download', {
        clientId: this.$route.params.clientId,
        documentId: item.id,
      });

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const fileName = response.headers['content-disposition'].match("filename='(.*)'");
      fileLink.setAttribute('download', fileName[1]);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('documents/delete', {
          clientId: this.$route.params.clientId,
          documentId: item.id,
        });
      }
    },
    formatDocumentType(type) {
      switch (type) {
        case 'invoice':
          return 'Factura';

        case 'livret':
          return 'Autorizatie';

        case 'contract':
          return 'Contract';

        case 'contract-anre':
          return 'Contract ANRE';

        case 'worksheet':
          return 'Fisa Lucrari';

        case 'report':
          return 'Proces Verbal';

        case 'vtp-anre-2':
        case 'vtp-anre-2-srb':
          return 'VTP Gaz la 2 ani';

        case 'vtp-anre-10':
        case 'vtp-anre-10-srb':
          return 'VTP Gaz la 10 ani';

        case 'pv-iugn-srb':
          return 'Proces Verbal IUGN';

        default:
          return 'Document necunoscut';
      }
    },
  },
};
</script>

<style scoped>
.color-default a button {
  color: white;
  text-decoration: none;
}
</style>
